import React from 'react';

import PipelineOverviewStaticTable from 'app/pipeline-details/shared/PipelineOverviewStaticTable';

import useStatusTableWithTags from './useStatusTableWithTags';

export default function StatusTableWithTags() {
  const props = useStatusTableWithTags();

  return <PipelineOverviewStaticTable {...props} />;
}
